import SETUP_WIZARDS_STEPS, { SETUP_WIZARDS } from '@/constants/setup-wizards'
import store from '@/store'
import { BUSINESS_FEATURES } from '@/constants/business-types'
import { PACKAGE_PERMISSIONS } from '@/constants/features'

export default [
  {
    title: 'navigation.marketing',
    svgIcon: 'icon-marketing',
    hide: () => !store.getters['permissions/isPrimaryAccount'] && !store.getters['subscription/isMobileAppPurchased'] && store.getters['setup/hideNewsletterWizard'],
    children: [
      {
        title: 'mobile.campaign.page-title',
        route: 'admin:mobile:notifications',
        svgIcon: 'icon-mobile-notifications',
        hide: () => !store.getters['subscription/isMobileAppPurchased'],

      },
      {
        title: 'whatsapp.title',
        route: 'admin:wp-campaigns',
        hide: () => !store.getters['subscription/isWhatsappMarketingPurchased'],

      },
      {
        title: 'navigation.surveys',
        route: 'admin:surveys',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.FEEDBACK,
        wizard: SETUP_WIZARDS.SURVEY,
        svgIcon: 'icon-customers-surveys',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.SURVEY]?.stepsNames ?? [],
        hide: () => !store.getters['permissions/isPrimaryAccount'],
      },
      {
        title: 'navigation.marketing-events',
        route: 'admin:marketing-events',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.MARKETING_EVENT,
        wizard: SETUP_WIZARDS.MARKETING_EVENTS,
        svgIcon: 'icon-coupons',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.MARKETING_EVENTS]?.stepsNames ?? [],
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.COUPONS) || (!store.getters['permissions/isPrimaryAccount'] && !store.getters['permissions/isBranchAdmin']),
      },
      {
        title: 'navigation.coupons',
        route: 'admin:coupons',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.COUPON,
        wizard: SETUP_WIZARDS.COUPONS,
        svgIcon: 'icon-coupons',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.COUPONS]?.stepsNames ?? [],
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.COUPONS) || (!store.getters['permissions/isPrimaryAccount'] && !store.getters['permissions/isBranchAdmin']),
      },
      {
        title: 'navigation.discounts',
        route: 'admin:discounts',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.DISCOUNT,
        wizard: SETUP_WIZARDS.DISCOUNTS,
        svgIcon: 'icon-discounts',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DISCOUNTS]?.stepsNames ?? [],
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.DISCOUNTS) || (!store.getters['permissions/isPrimaryAccount'] && !store.getters['permissions/isBranchAdmin']),
      },
      {
        title: 'navigation.newsletter',
        route: 'admin:newsletters',
        wizard: SETUP_WIZARDS.NEWSLETTER,
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.NEWSLETTER,
        svgIcon: 'icon-newsletter',
        hide: () => store.getters['setup/hideNewsletterWizard'],
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.NEWSLETTER]?.stepsNames ?? [],
      },
      {
        title: 'navigation.banners-pop-ups',
        svgIcon: 'icon-banners',
        route: 'admin:banners',
      },
      {
        title: 'navigation.campaigns',
        svgIcon: 'marketing-campaign',
        route: 'admin:campaigns',
      },
      {
        title: 'navigation.wallet-packages',
        route: 'admin:wallet-packages',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.WALLET_PACKAGES,
        svgIcon: 'icon-wallet-packages',
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.WALLET_PACKAGES) || (!store.getters['permissions/isPrimaryAccount'] && !store.getters['permissions/isBranchAdmin']) || (!store.getters['auth/user'].enable_wallet),
      },
    ],
  },
]
